module.exports = __webpack_public_path__ + "static/media/ourstories-screen_girl-clothing-store.71ea477d.png";